import { ToitEnPenteClimateTypes, ToitEnPenteStructureTypes } from "@iko-design-center/shared";
import React from "react";
import { Spacer } from "../../common/Spacer";
import { H1 } from "../../common/Typography";
import { RadioButton } from "../../common/RadioButton";
import { useToitStructure } from "./toitStructure.hooks";
import { Sidebar } from "../Sidebar";
import { getToitEnPenteStructureTranslations } from "./translations";
import { Intro, RadioButtonList } from "../../viewer/DesignCenter";
import { isMobile } from "../../../services/helpers.service";
import { useTabs } from "../../navigation/tabs.hook";

export const ToitStructure = () => {
  const {
    t,
    toitClimateType,
    toitStructureType,
    setToitStuctureType,
    nextButtonDisabled,
    handleNextButtonClick,
  } = useToitStructure();

  const { currentStep, tabs } = useTabs();
  const totalSteps = tabs.length

  return (
    <Sidebar
      handleNextButtonClick={handleNextButtonClick}
      nextButtonText={`${t("toitEnPente.toitStructure.nextButton")} (${currentStep + 1}/${totalSteps})`}
      nextButtonDisabled={nextButtonDisabled}
    ><Intro>
        <H1 lineHeightPx={33}>{t("toitEnPente.toitStructure.title")}</H1>
        {!isMobile() && <Spacer heightPx={32} />}
      </Intro>

      <RadioButtonList>
        {toitClimateType === ToitEnPenteClimateTypes.PLAIN_CLIMATE && (
          <RadioButton
            value={ToitEnPenteStructureTypes.ON_WOOD_RAFTERS}
            checked={toitStructureType === ToitEnPenteStructureTypes.ON_WOOD_RAFTERS}
            onClick={() => setToitStuctureType(ToitEnPenteStructureTypes.ON_WOOD_RAFTERS)}
            text={getToitEnPenteStructureTranslations(t, ToitEnPenteStructureTypes.ON_WOOD_RAFTERS)}
            disabled={false}
          />
        )}


        {toitClimateType === ToitEnPenteClimateTypes.PLAIN_CLIMATE && (<>
          {!isMobile() && <Spacer heightPx={10} />}
          <RadioButton
            value={ToitEnPenteStructureTypes.ON_WOOD_BOARDS}
            checked={toitStructureType === ToitEnPenteStructureTypes.ON_WOOD_BOARDS}
            onClick={() => setToitStuctureType(ToitEnPenteStructureTypes.ON_WOOD_BOARDS)}
            text={getToitEnPenteStructureTranslations(t, ToitEnPenteStructureTypes.ON_WOOD_BOARDS)}
            disabled={false}
          />
        </>
        )}

        {toitClimateType === ToitEnPenteClimateTypes.MOUNTAINOUS_CLIMATE && (
          <RadioButton
            value={ToitEnPenteStructureTypes.CONFORM_TO_MOUNTAINOUS_CLIMATE}
            checked={toitStructureType === ToitEnPenteStructureTypes.CONFORM_TO_MOUNTAINOUS_CLIMATE}
            onClick={() => setToitStuctureType(ToitEnPenteStructureTypes.CONFORM_TO_MOUNTAINOUS_CLIMATE)}
            text={getToitEnPenteStructureTranslations(t, ToitEnPenteStructureTypes.CONFORM_TO_MOUNTAINOUS_CLIMATE)}
            disabled={false}
          />
        )}
      </RadioButtonList>
    </Sidebar>
  );
};
